import BaseStore from './BaseStore';
import Song from '../models/Song';

class SongStore extends BaseStore {
	initialize() {
		this.song = new Song();
		this.song.on("SEQUENCE_PLAYING", this.handleChannelUpdateMessageFromSong.bind(this));
		this.song.on("SEQUENCE_QUEUED", this.handleChannelUpdateMessageFromSong.bind(this));
		this.song.on("REFRESH_SEQUENCES", this.handleChannelUpdateMessageFromSong.bind(this));
		this.playing = false;
		this.mapMode = false;
		this.selectedPath = false;
		this._maxListeners = 0;
	}

	handleChannelUpdateMessageFromSong(payload) {
		this.emitChannelUpdate(payload.channel);
	}

	emitChannelUpdate(channel) {
		this.emit("CHANNEL-" + channel + "-CHANGE");
		this.emit("LAUNCHPAD_SEQUENCE_GRID");
	}

	rehydrate(state) {
		this.song.rehydrate(state);
        this.emit('MIDI_BINDINGS_CHANGE');
	}

	getMidiBindings() {
		return this.song.midi.bindings;
	}

	dehydrate() {
		return this.song.dehydrate();
	}

	getChannelByNumber(number) {
		return this.song.channels[number];
	}

	getNoteGrid() {
		return this.song.getSelectedSequence().getSelectedBar();
	}

	getSelectedSequence() {
		return this.song.getSelectedSequence();
	}

	getSelectedChannel() {
		return this.song.getSelectedChannel();
	}

	getSeleted() {
		return this.song.getSelected();
	}

	getMasterChannel() {
		return this.song.masterChannel;
	}

	handleSequenceSelection(payload) {
		this.song.selectSequence(payload.channel, payload.sequence);
		this._triggerFullUpdate();
	}

	handleBarSelection(payload) {
		this.song.getSelectedSequence().setSelectedBar(payload.bar);
	}

	handleSongLoad(payload) {
		this.handleStop();
		this.rehydrate(payload);

		this._triggerFullUpdate();
		this.emit("AUDIO_GRAPH_REBUILD");
	}

	_triggerFullUpdate() {
		this.emit("NOTEGRID_SEQUENCE_UPDATE");
		this.emit("SELECTED_SEQUENCE_CHANGE");
		this.emit("BOTTOMVIEW_UPDATE");
		for(var i = 0; i < 8; i++) {
			this.emit("CHANNEL-" + i + "-CHANGE");
		}
		this.emit("TOPMENU_UPDATE");
		this.emit("LAUNCHPAD_SEQUENCE_GRID");
		this.emit("LAUNCHPAD_NOTE_GRID");
	}

	handleNoteToggle(payload) {
		var sequence = this.song.getSelectedSequence();
		var wasEmpty = sequence.empty;
		sequence.toggleNote(payload.bar, payload.beat, payload.note);
		if (wasEmpty) {
			this.emit("CHANNEL-" + sequence.channel + "-CHANGE");

			this.emit("LAUNCHPAD_SEQUENCE_GRID");
		}
		this.emit(wasEmpty ? "NOTEGRID_SEQUENCE_UPDATE" : "NOTEGRID_GRID_UPDATE");
		this.emit("LAUNCHPAD_NOTE_GRID");
	}

	handleSequenceSetBars(payload) {
		var sequence = this.song.getSelectedSequence();
		var wasEmpty = sequence.empty;
		sequence.setNumberOfBars(payload.bars);
		if (wasEmpty) {
			this.emit("CHANNEL-" + sequence.channel + "-CHANGE");
		}
		this.emit("NOTEGRID_SEQUENCE_UPDATE");
		this.emit("LAUNCHPAD_NOTE_GRID", { bar: sequence.selectedBar });
	}

	handleSequenceSetName(payload) {
		var sequence = this.song.getSelectedSequence();
		sequence.setName(payload.name);
		this.emit("CHANNEL-" + sequence.channel + "-CHANGE");
		this.emit("NOTEGRID_SEQUENCE_UPDATE");
		this.emit("LAUNCHPAD_SEQUENCE_GRID");
	}

	handleSequenceSelectBar(payload) {
		this.song.getSelectedSequence().setSelectedBar(payload.bar);
		this.emit("NOTEGRID_GRID_UPDATE");
		this.emit("LAUNCHPAD_NOTE_GRID", { bar: payload.bar });
	}

	_getParamFromPath(path) {
		path = path.split("_");
		var param = false;

		if(path[0] == "CHANNEL") {
			let channel;
			if(path[1] == "MASTER") {
				channel = this.song.masterChannel;
			} else {
				channel = this.song.channels[path[1]];
			}

			if(path[2] == "INSTRUMENT") {
				let instrument = channel.instrument;
				if(path[3] == "PARAM") {
					param = instrument.getParameterByName(path[4].toLowerCase());
				}
			} else if(path[2] == "EFFECT") {

				var effect = false;
				var effectPath  = "CHANNEL_" + path[1] + "_EFFECT_" + path[3];

				for(let i = channel.effects.length - 1; i >= 0; i--) {
					if(effectPath == channel.effects[i].path) {
						effect = channel.effects[i];
						break;
					}
				}
				if(effect && path[4] == "PARAM") {
					param = effect.getParameterByName(path[5].toLowerCase());
				}
			} else if(path[2] == "PARAM") {
				param = channel[path[3].toLowerCase()];
			}
		}

		return param;
	}

	handleParameterChange(payload) {
		var param = this._getParamFromPath(payload.path);

		if(param !== false) {
			if(typeof payload.normalized !== "undefined") {
				param.setNormalized(payload.normalized);
			} else {
				param.setValue(payload.value);
			}
			this.emit(payload.path + "_UPDATE", {
				value: param.value,
				normalized: param.normalized
			});
		}
	}

	handleParameterChangeMidi(payload) {
		var param = this._getParamFromPath(payload.path);
		if(param !== false) {
			param.setNormalized(payload.value);
			this.emit(payload.path + "_UPDATE", {
				value: param.value,
				normalized: param.normalized
			});
		}
	}

	handleEffectMove(payload){
		var channel = this.song.getSelectedChannel();
		var temp = channel.effects[payload.effect];
		channel.effects[payload.effect] = channel.effects[payload.effect+payload.amount];
		channel.effects[payload.effect+payload.amount] = temp;



		this.emit("AUDIO_GRAPH_EFFECT_MOVED", {
			from: payload.effect,
			to: payload.effect+payload.amount,
			channel: channel.number
		});

		this.emit("BOTTOMVIEW_UPDATE");
	}

	handleInstrumentAssignment(payload) {
		var channel = this.song.getSelectedChannel();
		var currentInstrument = channel.instrument;
		var changed = channel.assignInstrument(payload.type);
		if(changed) {
			this.emit("AUDIO_GRAPH_INSTRUMENT_SWAP", {
				prev: currentInstrument,
				next: channel.instrument,
				channel: channel.number
			});

		}
		this.emit("NOTEGRID_SEQUENCE_UPDATE");
		this.emit("BOTTOMVIEW_UPDATE");
	}

	handleAddEffect(payload) {
		var channel = this.song.getSelectedChannel();
		channel.addEffect(payload.type);

		this.emit("AUDIO_GRAPH_EFFECT_ADDED", {
			channel: channel.number
		});

		this.emit("BOTTOMVIEW_UPDATE");
	}

	handleEffectRemove(payload) {
		var channel = this.song.getSelectedChannel();
		channel.removeEffect(payload.effect);

		this.emit("AUDIO_GRAPH_EFFECT_REMOVED", {
			channel: channel.number,
			effect: payload.effect,
		});

		this.emit("BOTTOMVIEW_UPDATE");
	}

	handlePlay() {
		this.playing = true;
		this.emit("PLAY_SONG");
		this.emit("TOPMENU_UPDATE");
	}

	handleStop() {
		this.playing = false;
		this.emit('BEAT_GRID_UPDATE_POSITION', {
			beat: -1
		});
		this.emit("STOP_SONG");
		this.emit("TOPMENU_UPDATE");
		this.song.resetTracksToZero();

	}

	handleQueueSequence(payload) {
		var shouldPlay = this.song.channels[payload.channel].queueSequence(payload.sequence);
		if(payload.select) {
			this.handleSequenceSelection(payload);
		}

		if(!this.playing && shouldPlay) {
			this.handlePlay()
		}
	}

	handleBeatGridUpdate(payload) {
		this.emit('BEAT_GRID_UPDATE_POSITION', payload);
	}

	handleVUMeterUpdate(data) {
		this.emit('VU_METER_UPDATE', data);
	}

	handleSongLoadError(err) {
		this.handleNewSong();
	}

	handleNewSong() {
		this.initialize();
		this.emit("AUDIO_GRAPH_REBUILD");
		this.handleStop();
		this._triggerFullUpdate();
	}
	handleUserLogout() {
		this.song.can_save = false;
	}

	handleTonicUpdate(payload) {
		this.song.tonic = payload.tonic;
		this.emit("TOPMENU_UPDATE");
		this.emit("NOTEGRID_SEQUENCE_UPDATE");
	}

	handleKeyUpdate(payload) {
		this.song.key = payload.key;
		this.emit("TOPMENU_UPDATE");
		this.emit("NOTEGRID_SEQUENCE_UPDATE");
	}

	toggleMidiMapMode() {
		this.mapMode = !this.mapMode;
		//this._triggerFullUpdate();

		this.emit("MIDI_MAP_MODE_CHANGE", this.mapMode);
	}

	handleMidiMapSelect(payload) {
		if (!this.mapMode) return;
		if (payload.path) {
			this.selectedPath = payload.path;
		} else if (this.selectedPath !== false) {
			this.song.midi.add(payload, this.selectedPath);
			this.selectedPath = false;
			this.emit('MIDI_BINDINGS_CHANGE');
		}
	}
	handleSongNameUpdate(payload) {
		this.song.name = payload.name;
		this.emit("TOPMENU_UPDATE");
	}

	handleRemoveMidiBinding(payload) {
		this.song.midi.remove(payload.midi_path, payload.path);
		this.emit('MIDI_BINDINGS_CHANGE');
	}

	handleSetTempo(payload) {
		this.song.setTempo(payload.tempo);
		this.emit("TOPMENU_UPDATE");
		this.emit('TEMPO_CHANGE', payload);
	}

	handleSequenceDelete(payload) {
		this.song.channels[payload.channel].sequences[payload.sequence].makeEmpty();
		this.emit("CHANNEL-" + payload.channel + "-CHANGE");
		this.emit("NOTEGRID_SEQUENCE_UPDATE");
		this.emit("LAUNCHPAD_SEQUENCE_GRID");
	}

	handleVisibilityChange(payload) {
		this.song.visibility = payload.visibility;
		this.emit("TOPMENU_UPDATE");
	}
}

SongStore.storeName = "SongStore";
SongStore.handlers = {
	'NOTE_TOGGLE': 'handleNoteToggle',
	'SONG_LOAD': 'handleSongLoad',
	'SONG_LOAD_ERROR': 'handleSongLoadError',
	'NEW_SONG': 'handleNewSong',
	'SEQUENCE_SELECT': 'handleSequenceSelection',
	'BAR_SELECT': 'handleBarSelection',
	'SEQUENCE_SET_NUMBER_OF_BARS': 'handleSequenceSetBars',
	'SEQUENCE_SET_NAME': 'handleSequenceSetName',
	'SEQUENCE_SELECT_BAR': 'handleSequenceSelectBar',
	'PARAMETER_CHANGE': 'handleParameterChange',
	'PARAMETER_CHANGE_MIDI': 'handleParameterChangeMidi',
	'EFFECT_MOVE': 'handleEffectMove',
	'EFFECT_REMOVE': 'handleEffectRemove',
	'INSTRUMENT_ASSIGNMENT': 'handleInstrumentAssignment',
	'EFFECT_ADD': 'handleAddEffect',
	'PLAY_SONG': 'handlePlay',
	'STOP_SONG': 'handleStop',
	'SEQUENCE_QUEUE': 'handleQueueSequence',
	'BEAT_GRID_UPDATE_POSITION' : 'handleBeatGridUpdate',
	'VU_METER_UPDATE': 'handleVUMeterUpdate',
	'USER_NOT_LOGGED_IN': 'handleUserLogout',
	'SONG_TONIC_UPDATE': 'handleTonicUpdate',
	'SONG_KEY_UPDATE': 'handleKeyUpdate',
	'TOGGLE_MIDI_MAP_MODE': 'toggleMidiMapMode',
	'MIDI_MAP_SELECT': 'handleMidiMapSelect',
	'SONG_SET_NAME': 'handleSongNameUpdate',
	'MIDI_REMOVE_BINDING': 'handleRemoveMidiBinding',
	'SONG_SET_TEMPO': 'handleSetTempo',
	'SEQUENCE_DELETE': 'handleSequenceDelete',
	'SONG_SET_VISIBILITY': 'handleVisibilityChange'
};

export default SongStore;
